import { Security } from "../../../openapi/security"

export type SecurityState = {
    searchDone: boolean
    securities?: Security[]
    securitiesSearchCriteria?: FormData
    error? : string    
}

export  type SecurityDetailAction =
    | {
      type: "SecurityDetail/SEARCHDONE",
      payload: Security[],   
      searchCriteria: FormData 
    }
    | {
        type: "Security/RESETSEARCH"
    }
    | {
        type: "Security/FETCHERROR",
        payload: string
    }
  
    const initialState: SecurityState = { searchDone: false }


export    const securityDetailReducer = (
        state: SecurityState = initialState,
        action: SecurityDetailAction 
    ) => {        
        switch (action.type) {
            case "SecurityDetail/SEARCHDONE":
              return { ...state,  searchDone: true, securities: action.payload, securitiesSearchCriteria: action.searchCriteria }
            case "Security/RESETSEARCH" : {
                return { ...state,  searchDone: false }
            }
            case "Security/FETCHERROR" : {
                return { ...state,  searchDone: false, error: action.payload }
            }

            default: return state
        }
    }
    